import type { SVGProps } from 'react';

interface VeganIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  color?: string;
}

export function VeganIcon({ className, color = '#9EC600', ...props }: VeganIconProps) {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M7.01181 16.5C6.31049 14.5006 9.27765 10.5401 11.004 10.0979L7.01181 16.5Z" fill={color} />
      <path d="M6.52246 8.55055C6.88212 7.87766 7.07993 7.24321 7.09791 6.64722C6.75624 7.35857 6.57641 7.97379 6.52246 8.55055Z" fill={color} />
      <path d="M10.9115 13.9003C11.9905 14.0925 14.1125 14.1502 16.1445 12.4776C19.3814 9.78598 19.9209 3.32617 19.9928 0.5C19.831 0.5 19.6871 0.5 19.5253 0.5C15.8568 0.5 11.8287 1.48051 9.2751 3.76836C10.5159 6.15234 10.0484 8.99773 7.9084 11.7278C7.81849 11.8431 7.72859 11.9393 7.63867 12.0546C8.10622 12.7852 9.29308 13.6311 10.9295 13.9195L10.9115 13.9003Z" fill={color} />
      <path d="M7.38741 4.72687C5.96677 2.84276 2.63995 2.30444 0.5 2.22754C0.571931 5.22674 1.45308 8.51432 3.4132 10.0331C3.88075 10.3984 5.26544 11.4751 6.61415 9.74476C8.16066 7.78375 8.41242 6.09189 7.36942 4.70765L7.38741 4.72687Z" fill={color} />
    </svg>
  );
}
